var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main-content" },
    [
      _vm.modalData.open
        ? _c("sideBarInvoiceModalModal", {
            attrs: { modalData: _vm.modalData, onModalClose: _vm.closeModal },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-12" }, [
          _c("div", { staticClass: "card" }, [
            _vm.send_store
              ? _c("div", { staticClass: "card-body" }, [
                  _c(
                    "form",
                    {
                      attrs: { action: "" },
                      on: { submit: _vm.requestCalculation },
                    },
                    [
                      _c("div", { staticClass: "flex" }, [
                        _c("div", [
                          _vm._m(0),
                          _vm._v(" "),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.send_store,
                                  expression: "send_store",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: { name: "send_store" },
                              on: {
                                change: function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.send_store = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                },
                              },
                            },
                            _vm._l(
                              _vm.send_store_list,
                              function (store, index) {
                                return _c(
                                  "option",
                                  { key: index, domProps: { value: store.id } },
                                  [
                                    _vm._v(
                                      _vm._s(store.name) +
                                        "\n                  "
                                    ),
                                  ]
                                )
                              }
                            ),
                            0
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _c("label", [_vm._v("Склад получатель")]),
                          _vm._v(" "),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.receive_store,
                                  expression: "receive_store",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: { name: "receive_store" },
                              on: {
                                change: function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.receive_store = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                },
                              },
                            },
                            _vm._l(
                              _vm.receive_store_list,
                              function (store, index) {
                                return _c(
                                  "option",
                                  { key: index, domProps: { value: store.id } },
                                  [
                                    _vm._v(
                                      _vm._s(store.name) +
                                        "\n                  "
                                    ),
                                  ]
                                )
                              }
                            ),
                            0
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _c("label", [_vm._v("ID препарата для debug")]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.debugPrepId,
                                expression: "debugPrepId",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: { type: "number" },
                            domProps: { value: _vm.debugPrepId },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.debugPrepId = $event.target.value
                              },
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              position: "relative",
                              "min-width": "200px",
                            },
                          },
                          [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-info",
                                staticStyle: {
                                  position: "absolute",
                                  bottom: "0",
                                },
                                attrs: { type: "submit" },
                              },
                              [
                                _vm._v(
                                  "\n                  Создать автосписок\n                "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("label", { attrs: { for: "check_1" } }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.default_formula,
                                    expression: "default_formula",
                                  },
                                ],
                                staticClass: "from-control",
                                attrs: {
                                  type: "checkbox",
                                  name: "",
                                  id: "check_1",
                                },
                                domProps: {
                                  checked: Array.isArray(_vm.default_formula)
                                    ? _vm._i(_vm.default_formula, null) > -1
                                    : _vm.default_formula,
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a = _vm.default_formula,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.default_formula = $$a.concat([
                                            $$v,
                                          ]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.default_formula = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.default_formula = $$c
                                    }
                                  },
                                },
                              }),
                              _vm._v(
                                "\n                  Использовать 60/17\n                "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "clearfix" }),
                          ]
                        ),
                      ]),
                    ]
                  ),
                ])
              : _vm._e(),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("pulse-loader", {
            staticStyle: { "text-align": "center" },
            attrs: { loading: _vm.loading, color: _vm.color },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.request
        ? _c("div", [
            _vm.request.debug
              ? _c("div", [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-md-3" }, [
                      _c("div", { staticClass: "card" }, [
                        _c("div", { staticClass: "card-header" }, [
                          _vm._v(
                            "\n              Все запросы на все склады\n            "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "card-body" },
                          _vm._l(
                            _vm.request.debug.requests,
                            function (storeRequest, index) {
                              return _c("div", [
                                storeRequest.urgent
                                  ? _c("p", [
                                      _vm._v(
                                        _vm._s(_vm.printStoreName(index)) +
                                          " - urgent_reserve: "
                                      ),
                                      _c("strong", [
                                        _vm._v(_vm._s(storeRequest.urgent)),
                                      ]),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                storeRequest.regular
                                  ? _c("p", [
                                      _vm._v(
                                        _vm._s(_vm.printStoreName(index)) +
                                          " - regular_reserve: "
                                      ),
                                      _c("strong", [
                                        _vm._v(_vm._s(storeRequest.regular)),
                                      ]),
                                    ])
                                  : _vm._e(),
                              ])
                            }
                          ),
                          0
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-3" }, [
                      _c("div", { staticClass: "card" }, [
                        _c("div", { staticClass: "card-header" }, [
                          _vm._v(
                            "\n              На складах (-транзиты, -срочные)\n            "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "card-body" },
                          _vm._l(
                            _vm.request.debug.store1,
                            function (inStore, index) {
                              return _c("div", [
                                _c("p", [
                                  _vm._v(
                                    "(" +
                                      _vm._s(index) +
                                      ") " +
                                      _vm._s(_vm.printStoreName(index)) +
                                      ": "
                                  ),
                                  _c("strong", [_vm._v(_vm._s(inStore))]),
                                ]),
                              ])
                            }
                          ),
                          0
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-3" }, [
                      _c("div", { staticClass: "card" }, [
                        _c("div", { staticClass: "card-header" }, [
                          _vm._v("\n              Итерация 1\n            "),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "card-body" }, [
                          _c("p", [
                            _vm._v("Запрос на срочную бронь: "),
                            _c("strong", [
                              _vm._v(_vm._s(_vm.request.debug.urgent_request1)),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v("На складе получателя: "),
                            _c("strong", [
                              _vm._v(_vm._s(_vm.request.debug.store1_updated)),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v("Отправитель закрывает: "),
                            _c("strong", [
                              _vm._v(
                                _vm._s(_vm.request.debug.closing_request1)
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v("На отправителе: "),
                            _c("strong", [
                              _vm._v(
                                _vm._s(_vm.request.debug.send_store1_updated)
                              ),
                            ]),
                          ]),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-3" }, [
                      _c("div", { staticClass: "card" }, [
                        _c("div", { staticClass: "card-header" }, [
                          _vm._v(
                            "\n              Вычитаем срочные отправителя + дочерние\n            "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "card-body" }, [
                          _c("p", [
                            _vm._v("На отправителе: "),
                            _c("strong", [
                              _vm._v(
                                _vm._s(_vm.request.debug.send_store1_wo_ugrent)
                              ),
                            ]),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-md-3" }, [
                      _c("div", { staticClass: "card" }, [
                        _c("div", { staticClass: "card-header" }, [
                          _vm._v("\n              Итерация 2\n            "),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "card-body" }, [
                          _c("p", [
                            _vm._v("Запрос на обычную бронь: "),
                            _c("strong", [
                              _vm._v(
                                _vm._s(_vm.request.debug.debug_regular_requests)
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v("На складе получателя: "),
                            _c("strong", [
                              _vm._v(
                                _vm._s(_vm.request.debug.debug_updated_store2)
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v("Отправитель закрывает: "),
                            _c("strong", [
                              _vm._v(
                                _vm._s(_vm.request.debug.debug_closing_request2)
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v("На отправителе: "),
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  _vm.request.debug.debug_updated_send_store2
                                )
                              ),
                            ]),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-md-3" }, [
                      _c("div", { staticClass: "card" }, [
                        _c("div", { staticClass: "card-header" }, [
                          _vm._v(
                            "\n              Запрос на запас\n            "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "card-body" },
                          _vm._l(
                            _vm.request.debug.debug_store_request,
                            function (req, index) {
                              return _c("div", [
                                _c("p", [
                                  _vm._v(
                                    "(" +
                                      _vm._s(index) +
                                      ") " +
                                      _vm._s(_vm.printStoreName(index)) +
                                      ": "
                                  ),
                                  _c("strong", [_vm._v(_vm._s(req))]),
                                ]),
                              ])
                            }
                          ),
                          0
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-3" }, [
                      _c("div", { staticClass: "card" }, [
                        _c("div", { staticClass: "card-header" }, [
                          _vm._v("\n              Итерация 3\n            "),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "card-body" }, [
                          _c("p", [
                            _vm._v("Запрос на запас: "),
                            _c("strong", [
                              _vm._v(
                                _vm._s(_vm.request.debug.summary_store_request)
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v("Отправитель закрывает: "),
                            _c("strong", [
                              _vm._v(
                                _vm._s(_vm.request.debug.closing_store_request)
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v("На отправителе: "),
                            _c("strong", [
                              _vm._v(
                                _vm._s(_vm.request.debug.updated_send_store3)
                              ),
                            ]),
                          ]),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-3" }, [
                      _c("div", { staticClass: "card" }, [
                        _c("div", { staticClass: "card-header" }, [
                          _vm._v("\n              Суммарно\n            "),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "card-body" }, [
                          _c("p", [
                            _vm._v("Запрос на срочную бронь: "),
                            _c("strong", [
                              _vm._v(_vm._s(_vm.request.debug.urgent_request1)),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v("Отправитель закрывает: "),
                            _c("strong", [
                              _vm._v(
                                _vm._s(_vm.request.debug.closing_request1)
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v("Запрос на обычную бронь: "),
                            _c("strong", [
                              _vm._v(
                                _vm._s(_vm.request.debug.debug_regular_requests)
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v("Отправитель закрывает: "),
                            _c("strong", [
                              _vm._v(
                                _vm._s(_vm.request.debug.debug_closing_request2)
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v("Запрос на запас: "),
                            _c("strong", [
                              _vm._v(
                                _vm._s(_vm.request.debug.summary_store_request)
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v("Отправитель закрывает: "),
                            _c("strong", [
                              _vm._v(
                                _vm._s(_vm.request.debug.closing_store_request)
                              ),
                            ]),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-12" }, [
                _c("div", { staticClass: "card" }, [
                  _c("div", { staticClass: "card-body" }, [
                    _c("div", { staticClass: "flex blocks-2" }, [
                      _c("div", [
                        _c("div", [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.showNotClosed,
                                expression: "showNotClosed",
                              },
                            ],
                            attrs: { id: "check_all", type: "checkbox" },
                            domProps: {
                              checked: Array.isArray(_vm.showNotClosed)
                                ? _vm._i(_vm.showNotClosed, null) > -1
                                : _vm.showNotClosed,
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.showNotClosed,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.showNotClosed = $$a.concat([$$v]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.showNotClosed = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.showNotClosed = $$c
                                }
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("label", { attrs: { for: "check_all" } }, [
                            _vm._v(
                              "Показать препараты, которые не закрываются"
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.sendReserveOnly,
                                expression: "sendReserveOnly",
                              },
                            ],
                            attrs: { id: "check_2", type: "checkbox" },
                            domProps: {
                              checked: Array.isArray(_vm.sendReserveOnly)
                                ? _vm._i(_vm.sendReserveOnly, null) > -1
                                : _vm.sendReserveOnly,
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.sendReserveOnly,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.sendReserveOnly = $$a.concat([$$v]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.sendReserveOnly = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.sendReserveOnly = $$c
                                }
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("label", { attrs: { for: "check_2" } }, [
                            _vm._v("Отправить только брони"),
                          ]),
                        ]),
                        _vm._v(" "),
                        _vm.sendReserveOnly
                          ? _c("div", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.sendConfirmedOnly,
                                    expression: "sendConfirmedOnly",
                                  },
                                ],
                                attrs: { id: "check_3", type: "checkbox" },
                                domProps: {
                                  checked: Array.isArray(_vm.sendConfirmedOnly)
                                    ? _vm._i(_vm.sendConfirmedOnly, null) > -1
                                    : _vm.sendConfirmedOnly,
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a = _vm.sendConfirmedOnly,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.sendConfirmedOnly = $$a.concat([
                                            $$v,
                                          ]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.sendConfirmedOnly = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.sendConfirmedOnly = $$c
                                    }
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("label", { attrs: { for: "check_3" } }, [
                                _vm._v("Отправить только подтвержденные"),
                              ]),
                            ])
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-success",
                            on: { click: _vm.printTable },
                          },
                          [_vm._v("Печать")]
                        ),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _vm.request.data
              ? _c("div", [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-md-12" }, [
                      _vm.invoicesIncludedForAutolists &&
                      Object.keys(_vm.invoicesIncludedForAutolists).length
                        ? _c("div", { staticClass: "card" }, [
                            _vm._m(1),
                            _vm._v(" "),
                            _c("div", { staticClass: "card-body" }, [
                              _c(
                                "table",
                                { staticClass: "table table-sm table-hover" },
                                [
                                  _c(
                                    "tbody",
                                    _vm._l(
                                      _vm.invoicesIncludedForAutolists,
                                      function (invoice, index, i) {
                                        return _c("tr", [
                                          _c("td", [_vm._v(_vm._s(i + 1))]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _c("strong", [
                                              _vm._v(_vm._s(invoice.id)),
                                            ]),
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _c("span", {
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.printLabel(
                                                    invoice.status,
                                                    "status"
                                                  )
                                                ),
                                              },
                                            }),
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "badge badge-primary",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    invoice.type === 2
                                                      ? "транзит"
                                                      : "поступление"
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            invoice.type === 2
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "badge badge-primary",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$AllStores[
                                                          invoice.store_out
                                                        ] &&
                                                          _vm.$AllStores[
                                                            invoice.store_out
                                                          ].short_title
                                                      ) +
                                                        " ==> " +
                                                        _vm._s(
                                                          _vm.$AllStores[
                                                            invoice.store_in
                                                          ] &&
                                                            _vm.$AllStores[
                                                              invoice.store_in
                                                            ].short_title
                                                        )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]),
                                          _c("td", [
                                            _vm._v(_vm._s(invoice.comment)),
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.moment(
                                                  invoice.delivery_date,
                                                  "DD.MM.YYYY HH:mm"
                                                )
                                              )
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "text-right" },
                                            [
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "btn btn-xs btn-success",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.mixinGoToRouter(
                                                        "InvoicesEdit",
                                                        { id: invoice.id }
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("Показать")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "btn btn-xs btn-success newWindowBtn",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.openInNewPage(
                                                        "InvoicesEdit",
                                                        { id: invoice.id }
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "icon-fa icon-fa-external-link",
                                                  }),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "btn btn-xs btn-info newWindowBtn",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.openInvoiceInModal(
                                                        invoice.id
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "icon-fa icon-fa-eye",
                                                  }),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ])
                                      }
                                    ),
                                    0
                                  ),
                                ]
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "card" }, [
                        _c("div", { staticClass: "card-body" }, [
                          _c("div", { attrs: { id: "printTable" } }, [
                            _c(
                              "table",
                              {
                                staticClass: "table table-hover table-bordered",
                              },
                              [
                                _c("thead", [
                                  _c("tr", [
                                    _c("th", { staticClass: "wd-40" }),
                                    _vm._v(" "),
                                    _c("th", { staticClass: "wd-40" }),
                                    _vm._v(" "),
                                    _c("th", [_vm._v("Препарат")]),
                                    _vm._v(" "),
                                    _c(
                                      "th",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.sendConfirmedOnly,
                                            expression: "sendConfirmedOnly",
                                          },
                                        ],
                                        staticClass: "wd-200",
                                      },
                                      [_vm._v("Подтверждено")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "th",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: !_vm.sendReserveOnly,
                                            expression: "!sendReserveOnly",
                                          },
                                        ],
                                        staticClass: "wd-200",
                                      },
                                      [_vm._v("Всего")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "th",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.sendReserveOnly,
                                            expression: "sendReserveOnly",
                                          },
                                        ],
                                        staticClass: "wd-200",
                                      },
                                      [_vm._v("Бронь")]
                                    ),
                                    _vm._v(" "),
                                    _c("th", { staticClass: "wd-100" }, [
                                      _vm._v("Срочная бронь"),
                                    ]),
                                    _vm._v(" "),
                                    _c("th", { staticClass: "wd-100" }, [
                                      _vm._v("Обычная бронь"),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "th",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: !_vm.sendReserveOnly,
                                            expression: "!sendReserveOnly",
                                          },
                                        ],
                                        staticClass: "wd-100",
                                      },
                                      [_vm._v("Запас")]
                                    ),
                                    _vm._v(" "),
                                    _c("th", { staticClass: "wd-100" }, [
                                      _vm._v("Сумма"),
                                    ]),
                                    _vm._v(" "),
                                    _c("th", { staticClass: "wd-200" }, [
                                      _vm._v("Морион"),
                                    ]),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "tbody",
                                  _vm._l(
                                    _vm.orderedPrepNames(
                                      _vm.request.data.prep_names
                                    ),
                                    function (prep, index) {
                                      return _c(
                                        "tr",
                                        {
                                          key: index,
                                          class: {
                                            no_close: !prep.close,
                                            no_hover: !prep.close,
                                          },
                                        },
                                        [
                                          _c("td", [_vm._v(_vm._s(index + 1))]),
                                          _vm._v(" "),
                                          _c("td", [
                                            prep.cool
                                              ? _c("span", {
                                                  staticClass:
                                                    "icon icon-snowflake",
                                                })
                                              : _vm._e(),
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(prep.name) +
                                                "\n                      "
                                            ),
                                            prep.pack_comment
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "pack_details",
                                                  },
                                                  [
                                                    _c("br"),
                                                    _vm._v(
                                                      _vm._s(prep.pack_comment)
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            prep.pack_box_comment
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "store_details text-muted",
                                                  },
                                                  [
                                                    _c("br"),
                                                    _vm._v(
                                                      _vm._s(
                                                        prep.pack_box_comment
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: _vm.sendConfirmedOnly,
                                                  expression:
                                                    "sendConfirmedOnly",
                                                },
                                              ],
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.confirmedDrugs[prep.id]
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("td", {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: !_vm.sendReserveOnly,
                                                expression: "!sendReserveOnly",
                                              },
                                            ],
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.printSendPreps(prep)
                                              ),
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("td", {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: _vm.sendReserveOnly,
                                                expression: "sendReserveOnly",
                                              },
                                            ],
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.printSendPreps(
                                                  prep,
                                                  "reserve"
                                                )
                                              ),
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.request.data
                                                  .urgent_requests[prep.id]
                                              )
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.request.data
                                                  .regular_requests[prep.id]
                                              )
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: !_vm.sendReserveOnly,
                                                  expression:
                                                    "!sendReserveOnly",
                                                },
                                              ],
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.request.data
                                                    .store_requests[prep.id]
                                                )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: !_vm.sendReserveOnly,
                                                  expression:
                                                    "!sendReserveOnly",
                                                },
                                              ],
                                            },
                                            [_vm._v(_vm._s(prep.total_price))]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: _vm.sendReserveOnly,
                                                  expression: "sendReserveOnly",
                                                },
                                              ],
                                            },
                                            [_vm._v(_vm._s(prep.reserve_price))]
                                          ),
                                          _vm._v(" "),
                                          _c("td", [_vm._v(_vm._s(prep.id))]),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _c("p", [
                              _vm._v("Общая стоимоcть препаратов по списку: "),
                              _c("strong", [_vm._v(_vm._s(_vm.totalPrice))]),
                            ]),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", [
      _c("strong", [_vm._v("NEW")]),
      _vm._v(" Склад отправитель"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h6", [_vm._v("При построении автосписка были учтены инвойсы")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }